import { logtoGoogleOneTapCookieKey } from '@logto/connector-kit';
import { adminConsoleApplicationId, logtoCookieKey, logtoUiCookieGuard } from '@logto/schemas';
import { trySafe } from '@silverhand/essentials';
import { getCookie } from 'tiny-cookie';

// The server may rename the cookie (`SSO_COOKIE_NAME`) and tells us through the SSR payload.
const cookieName =
  (typeof logtoSsr === 'object' ? logtoSsr.logtoCookieName : undefined) ?? logtoCookieKey;

export const logtoCookies =
  trySafe(() => logtoUiCookieGuard.parse(getCookie(cookieName, JSON.parse))) ?? {};

export const shouldTrack = logtoCookies.appId === adminConsoleApplicationId;

export const logtoGoogleOneTapCookie =
  trySafe(() => {
    const cookieValue = getCookie(logtoGoogleOneTapCookieKey);
    return cookieValue ?? null;
  }) ?? null;
